import { service } from '@/utils/request'


export default {
	getList(data) {
		return service ({
			url: '/cloud/activity/studio-activity/getPages',
			method: 'post',
			data
		})
	},
	get(params) {
		return service ({
			url: '/cloud/activity/studio-activity/getById',
			method: 'get',
			params
		})		
	},
	add(data) {
		return service ({
			url: '/cloud/activity/studio-activity/add',
			method: 'post',
			data: data
		})		
	},
	update(data) {
		return service ({
			url: '/cloud/activity/studio-activity/update',
			method: 'post',
			data: data
		})		
	},
	// 下架活动
	offActive(data) {
		return service ({
			url: '/cloud/activity/studio-activity/online' + data,
			method: 'post',
		})	
	},
	// 获取领取奖品信息
	getRewardInfo(data) {
		return service ({
			url: '/cloud/activity/studio/activity/user/reward/findByPage',
			method: 'post',
			data
		})	
	},
	// 确认已发放
	confirmSend(id) {
		return service ({
			url: '/cloud/activity/studio/activity/user/reward/confirm?id=' + id,
			method: 'post',
		})	
	},
	// 奖品信息导出Excel
	exportExcel(params) {
		return service({
			url: '/cloud/activity/studio/activity/user/reward/exportExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/operateManage/studio_activity.js